import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as schoolsActions from 'Store/schools/actions';
import { toggleModal } from 'Store/ui/actions';
import * as reducers from 'Store/reducers';

import Button from 'Components/Button';
import ButtonWithNote from 'Components/ButtonWithNote';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class AddStudentButton extends React.Component {
  constructor(props) {
    super(props);

    this.addProps = {
      buttonType: 'secondary-mono',
      ctaIcon: 'plus',
      ctaIconBefore: true,
      label: (
        <ConnectedFormattedMessage id="users_list.add_student_button.add_label" />
      ),
    };

    this.doneProps = {
      buttonType: 'secondary-mono',
      ctaIcon: 'check',
      ctaIconBefore: false,
      label: (
        <ConnectedFormattedMessage id="users_list.add_student_button.done_label" />
      ),
    };
  }

  componentDidMount() {
    const {
      activeSchool,
      hideLimitCount,
      fetchSeatLimitsForSchool,
      type,
    } = this.props;
    if (
      !hideLimitCount &&
      (!activeSchool || !activeSchool.limits || !activeSchool.limits[type])
    ) {
      fetchSeatLimitsForSchool(activeSchool.id, 'students');
    }
  }

  render() {
    const {
      type,
      isModalActive,
      groupType,
      seatsUsed,
      seatLimit,
      hideLimitCount,
      ...extraProps
    } = this.props;
    const baseProps = isModalActive ? this.doneProps : this.addProps;
    const buttonProps = {
      ...baseProps,
      blurOnClick: true,
      clickHandler: () => this.props.toggleModal(`${groupType}-${type}`),
      ...extraProps,
    };
    const seatsLeft =
      seatLimit && !hideLimitCount ? seatLimit - seatsUsed : undefined;
    if (seatsLeft) {
      return (
        <ButtonWithNote
          button={<Button {...buttonProps} />}
          noteText={
            <ConnectedFormattedMessage
              id="users_list.seats_left"
              values={{ seats_left: seatsLeft }}
            />
          }
        />
      );
    }
    return <Button {...buttonProps} />;
  }
}

const mapStateToProps = (state, { type, groupType, hideLimitCount }) => {
  const activeSchool = reducers.getActiveSchool(state);
  return {
    isModalActive: reducers.isModalActive(state, `${groupType}-${type}`),
    activeSchool,
    seatLimit: !hideLimitCount
      ? reducers.getSchoolSeatLimit(state, activeSchool.id, 'students')
      : undefined,
    seatsUsed:
      !hideLimitCount && activeSchool.counts
        ? activeSchool.counts.students
        : undefined,
  };
};

AddStudentButton.propTypes = {
  isModalActive: PropTypes.bool.isRequired,
  activeSchool: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  fetchSeatLimitsForSchool: PropTypes.func.isRequired,
  hideLimitCount: PropTypes.bool,
};

AddStudentButton.defaultProps = {
  hideLimitCount: false,
};

export default connect(mapStateToProps, {
  toggleModal,
  fetchSeatLimitsForSchool: schoolsActions.fetchSeatLimitsForSchool,
})(AddStudentButton);
